import { Component } from '@angular/core';

@Component({
    selector: 'pdf-error-message',
    templateUrl: './pdf-error-message.component.html',
    standalone: false
})
export class PdfErrorMessageComponent {}
